<template>
  <b-card
    no-body
    class="card-company-table"
  >
    <b-card-header>
      <b-card-title>{{ $t('BVN & NIN Compliance') }}</b-card-title>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchRegulatoryCompliance"
      />
    </b-card-header>

    <div>
      <apexchart
        type="bar"
        :options="chartOptions"
        :series="chartSeries"
      />
    </div>

    <Spinner :show="isLoadingRegulatoryCompliance" />
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardTitle } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { mapActions } from 'vuex'
import Spinner from '@/views/components/spinner/Spinner.vue'

export default {
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    Spinner,
  },
  data() {
    return {
      isLoadingRegulatoryCompliance: false,
      apiData: [],
    }
  },
  computed: {
    chartOptions() {
      return {
        chart: { type: 'bar', stacked: true },
        plotOptions: { bar: { horizontal: false } },
        xaxis: { categories: ['Tier 1', 'Tier 2', 'Tier 3', 'Total'] },
        yaxis: {
          labels: { formatter: val => Math.round(val) },
          tickAmount: 3,
          min: 0,
          max: 1500,
        },
        dataLabels: { enabled: false },
      }
    },
    chartSeries() {
      const seriesMap = {}
      this.apiData.forEach(({ label, accountTierLevel, count }) => {
        if (!seriesMap[label]) {
          // Initialize Tier 1, 2, 3
          seriesMap[label] = [0, 0, 0]
        }
        // Assign count based on tier level
        seriesMap[label][accountTierLevel - 1] = count
      })

      // Convert to series format
      return Object.keys(seriesMap).map(name => ({
        name,
        // Add total automatically
        data: [...seriesMap[name], seriesMap[name].reduce((a, b) => a + b, 0)],
      }))
    },
  },
  mounted() {
    this.fetchRegulatoryCompliance()
  },
  methods: {
    ...mapActions({
      getDashboardRegulatoryCompliance: 'dashboard/getDashboardRegulatoryCompliance',
    }),
    async fetchRegulatoryCompliance() {
      this.isLoadingRegulatoryCompliance = true
      try {
        const response = await this.getDashboardRegulatoryCompliance()
        const { status, data } = response
        if (status === 200 && data) {
          this.apiData = data.summary || []
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoadingRegulatoryCompliance = false
      }
    },
  },
}
</script>
